import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ModalNavigator } from 'components';
import ProductList from '../product-list';

export default class ReplaceProduct extends React.Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.clickProductHandler = this.clickProductHandler.bind(this);
    this.filterSelectedProductCallback = this.filterSelectedProductCallback.bind(this);
    this.mapSolarKitListCallback = this.mapSolarKitListCallback.bind(this);
  }

  /* Handlers */

  clickProductHandler(product) {
    const { onSelectProduct, productObject } = this.props;

    if (onSelectProduct) {
      onSelectProduct(product, productObject, this);
    }
  }

  /* Methods */

  mapSolarKitListCallback(value) {
    if (!value) {
      return value;
    }

    const solarKit = value['solar-kit'];

    if (solarKit) {
      return solarKit;
    }

    return value;
  }

  // Not used anymore
  // TODO: remove
  filterSelectedProductCallback(value) {
    if (!value) {
      return false;
    }

    const { productObject } = this.props;

    if (!productObject) {
      return true;
    }

    const { name, productInfo } = productObject;

    if (!productInfo) {
      return true;
    }

    let valueId = value.id;

    if ((valueId === null || typeof (valueId) === 'undefined') && name === 'solar-kit') {
      const solarKit = value['solar-kit'];

      valueId = solarKit ? solarKit.id : null;
    }

    return productInfo.id !== valueId;
  }

  /* Render */

  render() {
    const {
      productObject,
      products,
      availableProducts,
    } = this.props;

    const productInfo = productObject ? productObject.productInfo : null;
    // const productData = productObject ? productObject.data : null; // Need this later
    const slotName = productObject ? productObject.name : null;

    const titleParams = {
      product: productInfo.name,
    };

    let productList = availableProducts;
    if (!productList) {
      // Old stuff
      productList = products;
      if (slotName === 'solar-kit') {
        productList = products.attributes.solar;
        productList = productList ? productList.map(this.mapSolarKitListCallback) : productList;
      } else if (productList && !Array.isArray(productList)) {
        const productPerSlot = products.attributes.sets;
        productList = productPerSlot[slotName];
      }
      if (productList) {
        productList = productList.filter(this.filterSelectedProductCallback);
      }
    }

    const views = [
      {
        title: <FormattedMessage id="configurator.replaceProductModal.title" values={titleParams} />,
        component: (
          <ProductList products={productList} onClickProduct={this.clickProductHandler} />
        ),
      },
    ];

    return (
      <ModalNavigator
        ref={this.modalNavigatorRefHandler}
        views={views}
      />
    );
  }
}

ReplaceProduct.propTypes = {
  productObject: PropTypes.object,
  // config: PropTypes.object, // Need this later
  products: PropTypes.object,
  availableProducts: PropTypes.array,

  onSelectProduct: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/replace-product/index.jsx